import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useCanvasStore } from '../../store/canvas-store';
import type { NoteFrame } from '../../store/types';

interface Props { frame: NoteFrame }

// Secondary: quiet ghost. Backward nav supports, never competes.
const ghostBtn =
  'flex items-center gap-0.5 text-[11px] font-semibold rounded-[5px] px-2.5 py-1 cursor-pointer ' +
  'bg-transparent text-[var(--color-text-muted)] border border-[var(--color-border)] ' +
  'hover:bg-[var(--color-menu-hover)]';

// Primary: the one obvious next step per onboarding card.
const primaryBtn =
  'flex items-center gap-0.5 text-[11px] font-semibold rounded-[5px] px-2.5 py-1 cursor-pointer ' +
  'bg-[var(--color-accent)] text-white border border-[var(--color-accent)]';

export function NoteFrameView({ frame }: Props) {
  const startTour = useCanvasStore((s) => s.startTour);
  const tourNext = useCanvasStore((s) => s.tourNext);
  const tourPrev = useCanvasStore((s) => s.tourPrev);
  // Dynamic per-note accent — runtime value, stays inline.
  const accent = frame.color ?? 'var(--color-tool-note)';

  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      className="h-full flex flex-col border-l-[3px] text-[13px] bg-[var(--color-surface)] text-[var(--color-text)]"
      style={{ borderLeftColor: accent }}
    >
      <div className="flex items-center gap-1.5 px-2.5 pt-2 pb-1 font-semibold">
        {frame.step !== undefined && (
          <span
            className="rounded-[5px] text-[11px] font-bold px-1.5 py-px text-[var(--color-tool-note-fg)]"
            style={{ background: accent }}
          >
            {frame.step}
          </span>
        )}
        <span>{frame.title}</span>
      </div>
      <div
        className="px-2.5 pt-0.5 pb-2.5 flex-1 overflow-auto leading-relaxed text-[var(--color-text-muted)]"
        dangerouslySetInnerHTML={{ __html: frame.html }}
      />
      {frame.tourId && (
        <div className="flex items-center gap-1.5 px-2.5 pb-2.5">
          <button className={ghostBtn} onClick={() => { startTour(frame.tourId!); tourPrev(); }}>
            <ChevronLeft size={13} /> Prev
          </button>
          <span className="flex-1" />
          <button className={primaryBtn} onClick={() => { startTour(frame.tourId!); tourNext(); }}>
            Next <ChevronRight size={13} />
          </button>
        </div>
      )}
    </div>
  );
}
